import React from 'react';
import { styled } from '@mui/material';
import { RocketLaunch } from '@mui/icons-material';
import { Colors } from 'library';
import { Chip, Icon, Row, Stack, Text } from 'library/ui';
import { GET_STARTED_CHIPS } from './shared';

export function GetStartedStep() {
    return (
        <Stack gap="md" align="center">
            <Icon icon={RocketLaunch} size="lg" tone="accent" iconColor={Colors.secondary} />
            <Text size="xl" weight="bold" align="center">
                Ready to post your first job?
            </Text>
            <CtaCopy>
                <Text size="md" tone="secondary" align="center" lineHeight="relaxed">
                    Post an upcoming substitute need and we&apos;ll match you with a qualified, compliant teacher from
                    our network.
                </Text>
            </CtaCopy>
            <Row gap="sm" wrap justify="center">
                {GET_STARTED_CHIPS.map((chip) => {
                    const ChipIcon = chip.icon;
                    return (
                        <Chip
                            key={chip.key}
                            padding="expanded"
                            bgColor={Colors.surface}
                            borderColor={Colors.border}
                            textColor={Colors.primary}
                        >
                            <ChipIcon sx={{ fontSize: 15, color: chip.color }} />
                            {chip.label}
                        </Chip>
                    );
                })}
            </Row>
        </Stack>
    );
}

const CtaCopy = styled('div')({
    maxWidth: 430,
    textAlign: 'center',
});
